import globalModule from '@/store/modules/global.module'
import RestClient from '../rest.client'
import { AxiosResponse } from 'axios'

export default class SessionService {
    static async getSession() {
        await RestClient.call({
            url: '/session/v2',
            method: 'get',
            headers: { Authorization: localStorage.getItem('token') },
        })
            .then(async (response: AxiosResponse) => {
                globalModule.setRouter('maps')
                globalModule.updateLoading(false)
                globalModule.setUser(response.data || {})
                await globalModule.Init()
            })
            .catch(() => {
                localStorage.clear()
                globalModule.setRouter('login')
                globalModule.updateLoading(false)
            })
    }

    static async login(email: string, password: string) {
        return await RestClient.call({
            url: '/session/v2',
            method: 'post',
            params: {
                email: email,
                password: password,
            },
        }).then(async (response: AxiosResponse) => {
            const token = response.data.token
            localStorage.setItem('token', token)
            globalModule.setRouter('/maps')
            globalModule.setUser(response.data || {})
            await globalModule.Init()
        })
    }
}
